var e=function(r){return r.TRUE="true",r.FALSE="false",r}({});export{e as HasSilicon};